import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { filter, map } from 'rxjs';
import { ViewportScroller } from '@angular/common';
import { PrimeNGConfig } from 'primeng/api';
import it from '../assets/locale/it.json';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit {

  constructor(private config: PrimeNGConfig, private router: Router, private titleService: Title, private viewportScroller: ViewportScroller) { }

  ngOnInit(): void {

    // Setto i vari componenti di PrimeNg in italiano
    this.config.setTranslation(it.it)

    // Ogni volta che viene cambiato la route
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd), map(() => {

      let route: ActivatedRoute = this.router.routerState.root;
      let routeTitle = '';      

      while (route!.firstChild) {
        route = route.firstChild;
      }
      
      // Recupero il titolo passato nel route e lo aggiungo alla tab
      if (route.snapshot.data['title']) {
        routeTitle = route!.snapshot.data['title'];
      }

      // Opzione per gli spettacoli, recupero il titolo dello spettacolo e lo aggiungo alla tab
      if (route.snapshot.params['titolo']) {
        routeTitle += ' ' + route.snapshot.params['titolo'].replace(/\-/gi, " ")
      }      
      
      return routeTitle;

    })).subscribe((title: string) => {

      // Setto il titolo della tab
      if (title) {
        this.titleService.setTitle(`Teatro Colosseo - ${title}`);
      }

      // Scroll to top salvo ancore abbecedario (#lettera / #definizione)
      const url = this.router.url;
      if (!(url.includes('abbecedario') && url.includes('#')))
        this.viewportScroller.scrollToPosition([0, 0]);

    });
  }
}
